import styled from "styled-components"
export const Wrapper = styled.div<{ footerState: boolean }>`
  display: ${({ footerState }) => (footerState ? "block" : "none")};

  width: 336px;
  /* height: 136px; */
  height: 95px;

  padding: 15px;
  /* border-radius: 20px; */
  border-radius: 0 0 20px 20px;
  background: rgba(48, 30, 86, 0.85);
  section {
    display: flex;
    justify-content: space-between;
    span {
      text-overflow: ellipsis;
      /* white-space: nowrap; */
      overflow: hidden;
      font-size: 14px;
    }
  }
  p {
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    line-height: 13px;
    color: #766599;
    margin-top: 5px;
  }
`

export const CashoutAt = styled.p`
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
`

export const BetsRemained = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: "#181731";
  background: #ff0000;
  border-radius: 100px;
  border: 3px solid #cb1212;
  height: 56px;
  width: 56px;
`
